import { onCLS } from 'web-vitals/attribution';
import type { CLSMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';

const onCumulativeLayoutShift = (report: (m: MetricReport) => void): void => {
  onCLS((metric: CLSMetricWithAttribution) => {
    const a = metric.attribution;
    report({
      name: 'cumulative-layout-shift',
      value: metric.value,
      unit: '',
      rating: metric.rating,
      navigationType: metric.navigationType,
      id: metric.id,
      delta: metric.delta,
      attribution: {
        kind: 'cls',
        largestShiftTarget: a?.largestShiftTarget,
        largestShiftTime: a?.largestShiftTime,
        largestShiftValue: a?.largestShiftValue,
        loadState: a?.loadState,
      },
    });
  });
};

export default onCumulativeLayoutShift;
